import React, { useEffect, useMemo, useRef, useState } from "react";
import "../../../css/Praplanning/ParaplanningCheckboxSelect.css";

const ParaplanningCheckboxSelect = ({
  label,
  required = false,
  value = [],
  options = [],
  placeholder = "Select options",
  helperText = "Select all relevant options",
  disabled = false,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedLabels = useMemo(() => {
    return options
      .filter((option) => value.includes(option.value))
      .map((option) => option.label);
  }, [options, value]);

  const displayValue = selectedLabels.length
    ? selectedLabels.join(", ")
    : placeholder;

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!dropdownRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const toggleDropdown = () => {
    if (disabled) return;
    setIsOpen((prev) => !prev);
  };

  const toggleOption = (optionValue) => {
    if (disabled) return;

    const alreadySelected = value.includes(optionValue);

    const nextValue = alreadySelected
      ? value.filter((item) => item !== optionValue)
      : [...value, optionValue];

    onChange(nextValue);
  };

  const clearAll = (event) => {
    event.stopPropagation();
    onChange([]);
  };

  return (
    <div
      ref={dropdownRef}
      className={`ParaplanningCheckboxSelect ${
        disabled ? "ParaplanningCheckboxSelect--Disabled" : ""
      }`}
    >
      {label && (
        <span className="ParaplanningField__Label">
          {label}
          {required && <span className="ParaplanningField__Required">*</span>}
        </span>
      )}

      <button
        type="button"
        className={`ParaplanningCheckboxSelect__Trigger ${
          isOpen ? "ParaplanningCheckboxSelect__Trigger--Open" : ""
        }`}
        onClick={toggleDropdown}
        disabled={disabled}
      >
        <span
          className={
            selectedLabels.length
              ? "ParaplanningCheckboxSelect__Value FP_Content black left"
              : "ParaplanningCheckboxSelect__Placeholder FP_Content"
          }
        >
          {displayValue}
        </span>

        <span className="ParaplanningCheckboxSelect__Right">
          {!!selectedLabels.length && (
            <span className="ParaplanningCheckboxSelect__Count">
              {selectedLabels.length}
            </span>
          )}

          {/* <span
            className={`ParaplanningCheckboxSelect__Chevron ${
              isOpen ? "ParaplanningCheckboxSelect__Chevron--Open" : ""
            }`}
          >
          </span> */}
          <span className="custom-select-arrow" />
        </span>
      </button>

      {isOpen && (
        <div className="ParaplanningCheckboxSelect__Menu">
          <div className="ParaplanningCheckboxSelect__MenuHeader">
            <span>{helperText}</span>

            {!!selectedLabels.length && (
              <button type="button" onClick={clearAll}>
                Clear
              </button>
            )}
          </div>

          <div className="ParaplanningCheckboxSelect__Options">
            {options.map((option) => (
              <div
                key={option.value}
                className="ParaplanningCheckboxSelect__Option"
                onClick={() => toggleOption(option.value)}
              >
                <input
                  checked={value.includes(option.value)}
                  type="checkbox"
                  onChange={() => toggleOption(option.value)}
                />

                <span className="Label-Medium">{option.label}</span>
              </div>
            ))}
          </div>

          <div className="ParaplanningCheckboxSelect__Footer">
            <button type="button" onClick={() => setIsOpen(false)}>
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ParaplanningCheckboxSelect;
